import { Metamodel } from '@ardoq/api-types';
import { MetamodelContext, MetamodelFieldContext } from 'metamodel/types';
import { getWorkspaceIdsFromContext } from 'metamodel/utils';
import { SimpleBlockDiagramContentType } from '@ardoq/simple-block-diagram/types';
import { t, type I18nLocale } from '@ardoq/i18n';

export const getWorkspaceNamesFromContext = (
  metamodel: Metamodel,
  context: MetamodelContext
): string[] => {
  const contextWorkspaceIds = getWorkspaceIdsFromContext(metamodel, context);
  const { workspaces } = metamodel.metamodel;
  return contextWorkspaceIds.map(
    contextWorkspaceId => workspaces[contextWorkspaceId].name
  );
};

export const getPopoverMessageFromContext = (
  context: MetamodelContext | undefined,
  i18nLocale: I18nLocale
): string => {
  if (context) {
    const { type } = context;
    const {
      COMPONENT,
      REFERENCE,
      REFERENCE_COMPLETENESS,
      WORKSPACE,
      WORKSPACE_FOLDER,
    } = SimpleBlockDiagramContentType;
    if ((context as MetamodelFieldContext).field) {
      return t(
        i18nLocale,
        'metamodel:stats.popover.openField',
        "Open this field's workspace:"
      );
    } else if (type === COMPONENT || type === REFERENCE_COMPLETENESS) {
      return t(
        i18nLocale,
        'metamodel:stats.popover.openComponentType',
        "Open this component type's workspace:"
      );
    } else if (type === REFERENCE) {
      return t(
        i18nLocale,
        'metamodel:stats.popover.openReferenceType',
        "Open this reference type's workspace:"
      );
    } else if (type === WORKSPACE) {
      return t(
        i18nLocale,
        'metamodel:stats.popover.openWorkspace',
        'Open this workspace:'
      );
    } else if (type === WORKSPACE_FOLDER) {
      return t(
        i18nLocale,
        'metamodel:stats.popover.openFolder',
        'Open all workspaces in this folder:'
      );
    }
  }
  return t(
    i18nLocale,
    'metamodel:stats.popover.openMetamodel',
    'Open all workspaces in this metamodel:'
  );
};
